import React, { useState } from 'react';
import PropTypes from 'prop-types';
import OutlinedTextField from '../../forms/textFields/OutlinedTextField';
import { formContainer, formSubText, formButton, giftMobileErrorStyles } from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { serverAjaxPromise } from '../../../utils/requests/request_helpers';
import FormButton from '../../forms/FormButton';

const RedemptionForm = ({ currencyCode, couponCode }) => {
  const redemptionStrings = StringConstantsMixin.strings.REDEMPTION_PAGE;

  const [code, setCode] = useState(couponCode || '');
  const [hasError, setError] = useState(false);
  const [giftMobileError, setGiftMobileError] = useState(false);

  const onChange = e => {
    if (hasError) {
      setError(false);
    }

    if (giftMobileError) {
      setGiftMobileError(false);
    }

    const value = e.target.value;
    setCode(value);
  };

  const redeemGiftCode = () => {
    return serverAjaxPromise({
      type: 'POST',
      contentType: 'application/json',
      url: `/api/alltrails/gift/${code}/redeem`,
      data: JSON.stringify({
        gift_id: code,
        currency: currencyCode
      })
    });
  };

  const onSubmit = async e => {
    e.preventDefault();

    try {
      await redeemGiftCode();
      window.location.href = '/pro/welcome';
    } catch (err) {
      if (err.responseJSON && err.responseJSON.errors) {
        const giftMobileSubActive = err.responseJSON.errors.find(error => {
          return error.code === 'gift_mobile_sub_active';
        });

        if (giftMobileSubActive) {
          setGiftMobileError(true);
        }
      }
      setError(true);
    }
  };

  return (
    <section>
      <form onSubmit={onSubmit} className={formContainer}>
        <OutlinedTextField
          type="text"
          changeHandler={onChange}
          value={code}
          label={redemptionStrings.REDEMPTION_CODE}
          errorMessage={hasError && StringConstantsMixin.strings.ERR_TRY_AGAIN}
        />
        {giftMobileError && <div className={giftMobileErrorStyles} dangerouslySetInnerHTML={redemptionStrings.MOBILE_GIFT} />}
        <FormButton value={redemptionStrings.REDEEM} disabled={hasError} className={formButton} />
      </form>
      <div className={formSubText}>{redemptionStrings.ONCE_YOU_REDEEM}</div>
    </section>
  );
};

export default RedemptionForm;

RedemptionForm.propTypes = {
  currencyCode: PropTypes.string,
  couponCode: PropTypes.string
};

RedemptionForm.defaultProps = {
  currencyCode: 'USD',
  couponCode: null
};
